export default __webpack_public_path__ + "static/media/Drooling.2638b9a4.svg";